import React from 'react';
import PropTypes from 'prop-types';
import MuiTextField from '@mui/material/TextField';
import { useMuiError } from 'hooks';
import { defaultMuiProps } from '../config';

// Utility: allow only valid event handlers
function filterProps(rest) {
  const cleaned = {};
  const validHandlers = [
    'onBlur',
    'onChange',
    'onClick',
    'onFocus',
    'onInput',
    'onKeyDown',
    'onKeyPress',
    'onKeyUp'
  ];

  Object.keys(rest).forEach(key => {
    if (key.startsWith('on')) {
      if (validHandlers.includes(key) && typeof rest[key] === 'function') {
        cleaned[key] = rest[key];
      }
    } else {
      cleaned[key] = rest[key];
    }
  });

  return cleaned;
}

function TextField({ error, ...rest }) {
  const safeProps = filterProps(rest);

  return (
    <MuiTextField
      {...safeProps}
      {...defaultMuiProps}
      {...useMuiError(error)}
      fullWidth
      margin="normal"
      InputLabelProps={{
        style: {
          textAlign: 'left',
          color: '#555',
          fontWeight: 500
        },
        ...(safeProps.InputLabelProps || {})
      }}
    />
  );
}

TextField.propTypes = {
  error: PropTypes.string
};

export default React.memo(TextField);
